exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.module-container[data-v-a2e33b94] {\r\n    display: flex;\r\n    flex-wrap: wrap;\n}\n.cards-container[data-v-a2e33b94] {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\n}\n.card-status-center[data-v-a2e33b94] {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\n}\r\n", ""]);

// exports
